import { Loader } from '@src/components';
import { useBusinessCheckContext } from '@src/contexts/business-check-context';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PlainLayout = () => {
  const { resolvedPath } = useBusinessCheckContext();

  if (resolvedPath) {
    if (resolvedPath === 'loading') return <Loader />;
    return <Navigate to={resolvedPath} replace />;
  }

  return <Outlet />;
};

export default PlainLayout;
